module.exports = __webpack_public_path__ + "img/login_candidati_jobmule_home.aac18e42.jpg";